export interface SelectedResponse {
  lead_id? : number;
  type? : string
  status? : string;
  lenders? : Array<SelectedList>;
}

export interface SelectedList {
  id : number;
  bank_name: string;
  note: string;
  position: number;
  checked: boolean;
  featured: boolean;
  logo?: string;
  send_type?: string;
}

export const DefaultSelectedResponse: SelectedResponse = {
  lead_id: 1,
  type: 'fru',
  status: 'Default',
  lenders: [
    {
      "id": 22785,
      "bank_name": "loanDepot",
      "note": "loanDepot",
      "position": 1,
      "checked": true,
      "featured": true,
      "logo": "",
      "send_type": "shared"
    },
    {
      "id": 22783,
      "bank_name": "Rocket Mortgage",
      "note": "Rocket Mortgage",
      "position": 2,
      "checked": true,
      "featured": true,
      "logo": "",
      "send_type": "shared"
    }
  ]
}

export const DefaultSelectedResponseUnchecked: SelectedResponse = {
  lead_id: 1,
  type: 'fru',
  status: 'Default',
  lenders: [
    {
      "id": 22785,
      "bank_name": "loanDepot",
      "note": "loanDepot",
      "position": 1,
      "checked": false,
      "featured": true,
      "logo": "",
      "send_type": "shared"
    },
    {
      "id": 22783,
      "bank_name": "Rocket Mortgage",
      "note": "Rocket Mortgage",
      "position": 2,
      "checked": false,
      "featured": true,
      "logo": "",
      "send_type": "shared"
    }
  ]
}
